
import { getPartnerLastActiveProjectOptions } from "@/services/queryOptions/partnerQueryOptions";
import { useQuery } from "@tanstack/react-query";
import usePartner from "./usePartner";

export default function usePartnerLastActiveProject() {
    const { data: partner } = usePartner();
    const query = useQuery(getPartnerLastActiveProjectOptions(partner?.id));

    return query;
}
